import { Typography } from '@mui/material';
import { EDashboardWidgetTypes, type IDashboardWidgetProps } from '@sharedInterfaces/IDashboard';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import { EnhancedMvpChatAgent } from '@src/App/Components/_UnderConstruction/MvpChatAgent-2';
import type { TWidgetDefinition } from '@src/App/Pages/DashboardPage/Dashboard/Dashboard';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

import styles from './AgentChatDashboardWidget.module.css';

const AgentChatDashboardWidget: React.FC<IDashboardWidgetProps<EDashboardWidgetTypes.agentChatWidget>> = ({
    id,
    params,
    isEditing,
    onParamChange,
}) => {
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).dashboard;
    if (isEditing)
        return (
            <>
                <Typography>{langStrings.noSettings}</Typography>
            </>
        );

    return (
        <div className={styles.agentBox}>
            <EnhancedMvpChatAgent key={id} fullWidth={true} />
        </div>
    );
};

export const agentChatDashboardWidgetDefinition = {
    type: EDashboardWidgetTypes.agentChatWidget,
    render: AgentChatDashboardWidget,
    overrideCardDesign: false,
    defaultParams: {},
} satisfies TWidgetDefinition;
